<template>
    <div id="app" ref="app" class="pr">
        <div style="top: 0;position: sticky;height: 0px;" class="zi-9 ">
            <div :class=" 'header  flex al-c jc-sb wh-auto  pa-lt animated fadeInDown ' "
                 :style="`background:rgba(13, 13, 13, ${alphas});`"
            >
                <div :class="'fl ht-auto ani pd-v-10 cp ' + (scale_ratio < 1 ? 'mr-l-20' : 'mr-l-70 ')" @click="click_logo">
                    <img :class="' ani  '"
                         :src="$store.state.system.system_data.logo|img"
                         :style="'height: ' + (scale_ratio < 1 ? 30 : 56) + 'px;'"
                    />
                </div>
                <div v-if="scale_ratio < 1" class="pa-rt ht-auto flex al-c pd-h-20">
                    <span class="iconfont icon-liebiao cr-white txt-size-26" @click="show_nav = !show_nav"></span>
                </div>
                <div class="fr ht-auto mr-r-70 flex  txt-size-16 lh-32" v-else>
                    <div :class=" 'nav pd-20 bs-bb cp w-min-80 tc pr ' + (nav_value === index ? 'sed' : '') "
                         :data-name="item.val"
                         @click="click_nav(item.val,index)"
                         v-for="(item, index) in nav_list"
                         :key="index"
                    >
                        <div :class="'nav-bg ani pa-lt zi-1 wh-auto bg-primary '"></div>
                        <div class="pr zi-9 text ani">{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </div>
        <router-view/>
        <u-popup :isShow.sync="show_nav" propPosition="right" width="70%" title="数城科技">
            <div class="pr pd-t-40 pd-b-30">
                <div class="pr">
                    <div class="pa wh-auto bg-primary ani" style="height: 40px;" :style="{top:nav_value*40+'px'}"></div>
                    <div :class="'tc pr pd-v-10 ani lh-20 cr-white txt-size-16 '+(nav_value === index?'cr-white':'')"
                         @click="click_nav(item.val,index)"
                         v-for="(item, index) in nav_list">{{item.name}}</div>
                </div>
            </div>
        </u-popup>
    </div>
</template>
<script>
import uPopup from './components/u-popup/u-popup.vue'
export default {
    components:{
        uPopup
    },
    data() {
        return {
            alphas:0,
            show_nav: false,
            isFixed: false,
            nav_value: 0,
            nav_list: [
                // {name: '首页',val: 'home'},
                // {name: '公司介绍',val: 'introduce'},
                // {name: '项目案例',val: 'case'},
                // {name: '公司产品',val: 'product'},
                // {name: '业务板块',val: 'service'},
                // {name: '荣誉资质',val: 'honor'},
                // {name: '新闻动态',val: 'news'},
                // {name: '招贤纳士',val: 'join'},
            ],
        };
    },
    methods: {
        addJsonLdScript() {
            const script = document.createElement("script");
            script.type = "application/ld+json";
            script.text = JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "成都数城科技",
                "description": "成都数城科技有限公司官方网站。",
                "url": "https://www.dcocd.cn",
                "logo": "https://www.dcocd.cn/logo.png"
            });
            document.head.appendChild(script);
        },
        /**
         *@Description 查询导航菜单
         *@author liujiaji
         */
        get_nav(){
            this.$api.post('/home/getModuleHideManageList',{}).then(res=>{
                if(res.status === 200){
                    this.nav_list = res.data||[];
                }
            })
        },
        findIndexByName(name) {
            for (let i = 0; i < this.nav_list.length; i++) {
                if (this.nav_list[i].val === name) {
                    return i;
                }
            }
            return -1;
        },
        get_route_name(name){
            this.nav_value = this.findIndexByName(name);
            if(name!=='home') this.alphas = 1;
            else this.alphas = 0;
        },
        click_nav(name,index){
            console.log(name,index)
            this.nav_value = index;
            let current = this.$route.name;
            if(current===name) return null;
            else {
                this.url_to_link({name:name}, false);
            }
        },
        click_logo(){
            let current = this.$route.name;
            if(current!=='home') this.url_to_link({name:'home'}, false);;
        },
        /**
         *@name 监听滚动条
         *@author liujiaji
         */
        handleScroll() {
            const name = this.$route.name;
            if (name !== 'home') {
                this.isFixed = true;
                return false;
            };
            const scrollTop = document.getElementById('app').scrollTop;
            if (this.alphas<=1){
                this.alphas = scrollTop/400;
            }else{
                this.alphas =1;
            }
        },
    },
    computed:{
        scale_ratio: function () {
            return Number(this.$store.state.system.scale_ratio);
        },
    },
    watch:{
        scale_ratio(newV){
            if(newV<1) this.show_nav = false;
        },
        $route(to) {
            setTimeout(()=>{
                this.show_nav = false;
                const name = to.name;
                this.get_route_name(name)
            },300)
        },
    },
    created() {
        this.get_nav();
        const name = this.$route.name;
        this.get_route_name(name);
    },
    mounted() {
        this.addJsonLdScript();
        let scrollView = document.getElementById('app');
        scrollView.addEventListener('scroll', this.handleScroll, true);

    }
};
</script>

<style lang="less" scoped>
.header {
    .nav{
        &-bg{
            height: 0;
        }
        .text{
            color:rgba(255,255,255,0.8);
        }
        &:hover{
            .text {
                color:rgba(255,255,255,1);
                text-shadow: 0 0 5px #fff;
            }
        }
    }
}
.sed{
    .nav-bg{
        height: 72px !important;
    }
    .text {
        color:rgba(255,255,255,1);
        text-shadow: 0 0 5px #fff;
    }
}
</style>